export default "__VITE_ASSET__CKkEd8S___"